import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PmsComponent } from './pms/pms.component';
import { EmployeeMasterComponent } from './employee-master/employee-master.component';
import { ImportFilesComponent } from './import-files/import-files.component';
import { ProfileManagementComponent } from './profile-management/profile-management.component';
import { ImportHistoryComponent } from './import-history/import-history.component';
import { HrAdminMyHomeComponent } from './hr-admin-my-home/hr-admin-my-home.component';
import { AdminAccessMatrixComponent } from './admin-access-matrix/admin-access-matrix.component';
import { CompetencyManagementComponent } from './competency-management/competency-management.component';
import { IncrementComponent } from './increment/increment.component';
import { AuditLogsComponent } from './audit-logs/audit-logs.component';
import { TaskManagementsComponent } from './task-managements/task-managements.component';
import { CompetencyHistoryComponent } from './competency-history/competency-history.component';
import { IncrementLetterComponent } from './increment-letter/increment-letter.component';
import { EmailContentComponent } from './email-content/email-content.component';
import { UploadfileComponent } from './uploadfile/uploadfile.component';
import { GenerateIncrementLettersComponent } from './generate-increment-letters/generate-increment-letters.component';
import { VariablePayComponent } from './variable-pay/variable-pay.component';
import { VariablePayEmailContentComponent } from './variable-pay-email-content/variable-pay-email-content.component';
import { VariablePayLetterComponent } from './variable-pay-letter/variable-pay-letter.component';
import { VariablePayUploadfileComponent } from './variable-pay-uploadfile/variable-pay-uploadfile.component';
import { VariablePayLogsComponent } from './variable-pay-logs/variable-pay-logs.component';
import { GenerateVariablePayLettersComponent } from './generate-variable-pay-letters/generate-variable-pay-letters.component';
import { OrganizationalStructureComponent } from './organizational-structure/organizational-structure.component';
import { IncrementLogsComponent } from './increment-logs/increment-logs.component';
import { ESSComponent } from './ess/ess.component';
import { EssLogsComponent } from './ess-logs/ess-logs.component';
import { ThreeSixtyDegreeComponent } from './three-sixty-degree/three-sixty-degree.component';
import { ThreeSixtyDegreeLogsComponent } from './three-sixty-degree-logs/three-sixty-degree-logs.component';
import { ExpenseComponent } from './expense/expense.component';
import { ExpenceLogsComponent } from './expence-logs/expence-logs.component';
import { AssestManagementComponent } from './assest-management/assest-management.component';
import { AssetErrorLogComponent } from './asset-error-log/asset-error-log.component';
import { NineBoxComponent } from './9Box/nine-box/nine-box.component';
import { NineBoxLogComponent } from './9Box/nine-box-log/nine-box-log.component';
import { ElcmComponent } from './ELCM/elcm/elcm.component';
import { AttritiontabsComponent } from './Attrition/attritiontabs/attritiontabs.component';
import { AttritionDemographicComponent } from './Attrition/attrition-demographic/attrition-demographic.component';
import { AttritionScoreExpWiseComponent } from './Attrition/attrition-score-exp-wise/attrition-score-exp-wise.component';
import { AttritionSalaryLeaveWiseComponent } from './Attrition/attrition-salary-leave-wise/attrition-salary-leave-wise.component';
import { AttritionsetupComponent } from './Attrition/attritionsetup/attritionsetup.component';
import { AttritionLogsComponent } from './Attrition/attrition-logs/attrition-logs.component';
import { LNDComponent } from './Learning-n-Development/l-n-d/l-n-d.component';
import { LndSetupComponent } from './Learning-n-Development/lnd-setup/lnd-setup.component';
import { NineBoxDashboardComponent } from './9Box/nine-box-dashboard/nine-box-dashboard.component';
import { ElcmLogsComponent } from './ELCM/elcm-logs/elcm-logs.component';
import { GrievanceComponent } from './grievance/grievance.component';

import { DwmTabsComponent } from './DWM-Plus/dwm-tabs/dwm-tabs.component';
import { DwmSetupComponent } from './DWM-Plus/dwm-setup/dwm-setup.component';
import { EmployeeeDwmComponent } from './DWM-Plus/employeee-dwm/employeee-dwm.component';
import { MyDwmCreateComponent } from './DWM-Plus/My-DWM/my-dwm-create/my-dwm-create.component';
import { MyDwmUpdateComponent } from './DWM-Plus/My-DWM/my-dwm-update/my-dwm-update.component';
import { DwmReportComponent } from './DWM-Plus/Reports/dwm-report/dwm-report.component';
import { ReviewTeamDwmComponent } from './DWM-Plus/team-DWM/review-team-dwm/review-team-dwm.component';
import { ApproveTeamDwmComponent } from './DWM-Plus/team-DWM/approve-team-dwm/approve-team-dwm.component';
import { DwmdashboardComponent } from './DWM-Plus/DWM-Dashboard/dwmdashboard/dwmdashboard.component';
import { SubAdminComponent } from './DWM-Plus/Sub-Admin/sub-admin/sub-admin.component';
import { DwmDumpReportComponent } from './DWM-Plus/Reports/dwm-dump-report/dwm-dump-report.component';
import { DwmReportTabsComponent } from './DWM-Plus/Reports/dwm-report-tabs/dwm-report-tabs.component';
const routes: Routes = [
  {
    path: 'pms',
    component: PmsComponent
  },
  {
    path: 'payroll',
    loadChildren: () => import('./payroll/payroll.module').then(module => module.PayrollPageModule)
  },
  {
    path: 'employeemaster',
    component: EmployeeMasterComponent
  },
  {
    path: 'importFiles',
    component: ImportFilesComponent
  },
  {
    path: 'importHistory',
    component: ImportHistoryComponent
  },
  {
    path: 'profileManagement',
    component: ProfileManagementComponent
  },
  {
    path: 'myhome',
    component: HrAdminMyHomeComponent
  },
  {
    path: 'accessmatrix',
    component: AdminAccessMatrixComponent
  },
  // {
  //   path : 'competency',
  //   component :CompetencyManagementComponent
  // },
  {
    path: 'increment',
    component: IncrementComponent
  },
  {
    path: 'auidtlogs',
    component: AuditLogsComponent
  },
  {
    path: 'taskmanagements',
    component: TaskManagementsComponent
  },
  // {
  //   path : 'coompetencyHistory',
  //   component : CompetencyHistoryComponent
  // },
  {
    path: 'dwmplus',
    component: DwmTabsComponent,
    children: [
      {
        path: '',
        redirectTo: 'dwm-dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dwm-dashboard',
        component: DwmdashboardComponent
      },
      {
        path: 'create-dwm',
        component: MyDwmCreateComponent
      },
      {
        path: 'update-dwm',
        component: MyDwmUpdateComponent
      },
      {
        path: 'approve-dwm',
        component: ApproveTeamDwmComponent
      },
      {
        path: 'review-dwm',
        component: ReviewTeamDwmComponent
      },
      {
        path: 'exited-dwm',
        component: ReviewTeamDwmComponent,
        data: { exitedOnly: true }
      },
      //   {
      //     path: 'dump-reports',
      //   component: DwmDumpReportComponent
      // },
      // {
      //   path: 'dwm-reports',
      //   component: DwmReportComponent
      // },
      {
        path: 'employee-dwm',
        component: EmployeeeDwmComponent
      },
      {
        path: 'rndadmin',
        component: SubAdminComponent
      },
        {
      path: 'reports',
      component: DwmReportTabsComponent,
      children: [
        {
          path: '',
          redirectTo: 'dwm-reports',
          pathMatch: 'full'
        },
        {
          path: 'dwm-reports',
          component: DwmReportComponent
        },
        {
          path: 'dump-reports',
          component: DwmDumpReportComponent
        }
      ]
    },
    ]
  },


  {
    path: 'dwmplus-setup',
    component: DwmSetupComponent
  },
  {
    path: 'incrementLetter',
    component: IncrementLetterComponent
  },
  {
    path: 'increment/emailContent',
    component: EmailContentComponent
  },
  {
    path: 'increment/uploadfile',
    component: UploadfileComponent
  },
  {
    path: 'increment/generateIncrementLetters',
    component: GenerateIncrementLettersComponent
  },
  {
    path: 'incrementLogs',
    component: IncrementLogsComponent
  },
  {
    path: 'variablepay',
    component: VariablePayComponent
  },
  {
    path: 'variablepay/variablepayEmailContent',
    component: VariablePayEmailContentComponent
  },
  {
    path: 'variablepay/variablepayLetter',
    component: VariablePayLetterComponent
  },
  {
    path: 'variablepayUploadFile',
    component: VariablePayUploadfileComponent
  },
  {
    path: 'variablepay/variablePayLogs',
    component: VariablePayLogsComponent
  },
  {
    path: 'variablepay/generateVariablePayLetter',
    component: GenerateVariablePayLettersComponent
  },
  {
    path: 'organizationalStructure',
    component: OrganizationalStructureComponent
  },
  {
    path: 'ess',
    component: ESSComponent
  },
  {
    path: 'essLogs',
    component: EssLogsComponent
  },
  {
    path: 'threeSixtyDegree',
    component: ThreeSixtyDegreeComponent
  },
  {
    path: 'nineBox',
    component: NineBoxComponent
  },
  {
    path: 'threeSixtyDegree/logs',
    component: ThreeSixtyDegreeLogsComponent
  },
  {
    path: 'expense',
    component: ExpenseComponent
  },
  {
    path: 'expense-logs',
    component: ExpenceLogsComponent
  },
  {
    path: 'asset-management',
    component: AssestManagementComponent
  },
  {
    path: 'asset-logs',
    component: AssetErrorLogComponent
  },
  /* {
  path: 'nine-box',
  component: NineBoxComponent
  }, */
  {
    path: 'nineBox',
    component: NineBoxComponent
  },
  {
    path: 'ninebox-log',
    component: NineBoxLogComponent
  },
  {
    path: 'elcm',
    component: ElcmComponent
  },
  {
    path: 'elcm-logs',
    component: ElcmLogsComponent
  },
  {
    path: 'attrition',
    component: AttritiontabsComponent
  },
  {
    path: 'attrition',
    component: AttritionDemographicComponent
  },

  {
    path: 'attrition',
    component: AttritionScoreExpWiseComponent
  },
  {
    path: 'attrition',
    component: AttritionSalaryLeaveWiseComponent
  },
  {
    path: 'attrition-setup',
    component: AttritionsetupComponent
  },
  {
    path: 'attrition-logs',
    component: AttritionLogsComponent
  },

  {
    path: 'lnd',
    component: LNDComponent
  },

  {
    path: 'lnd-setup',
    component: LndSetupComponent
  },
  {
    path: 'employee-concern',
    component: GrievanceComponent
  },
  {
    path: 'sp-pd-spd',
    loadChildren: () => import('./SP_CP_SPD/sp-pd-spd/sp-pd-spd.module').then(m => m.SpPdSpdPageModule)
  },
  {
    path: 'recruitment',
    loadChildren: () => import('./recruitment/recruitment.module').then(m => m.RecruitmentPageModule)
  },
  {
    path: 'competency',
    loadChildren: () => import('./competency/competency.module').then(m => m.CompetencyModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HradminRoutingModule {}
